import * as React from 'react';
import {  MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentExample } from "../components/ComponentExample";
import { ContextExample } from "../ContextExample";

export const exampleComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (identification.componentId === "EXMPL" && identification.reportId === "example") {
    input.component = <ComponentExample context={componentContext as ContextExample}></ComponentExample>;
  }
  return next(input);
};
